import { render, staticRenderFns } from "./oring.vue?vue&type=template&id=3a2b8014&scoped=true&"
import script from "./oring.vue?vue&type=script&lang=js&"
export * from "./oring.vue?vue&type=script&lang=js&"
import style0 from "./oring.vue?vue&type=style&index=0&id=3a2b8014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b8014",
  null
  
)

export default component.exports